import { useUI } from '../context/AppContext.jsx';

export default function ProgressOverlay() {
  const { isLoading, loadingProgress, loadingText } = useUI();
  
  if (!isLoading) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-bg-secondary rounded-lg p-8 max-w-md w-full mx-4">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
          <div className="text-text-primary text-center">{loadingText}</div>
          <div className="w-full bg-bg-tertiary rounded-full h-2">
            <div 
              className="bg-primary h-2 rounded-full transition-all duration-300"
              style={{ width: `${loadingProgress}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}


